import util from '../util';

export const ACCESSORY_CONFIG = 'ACCESSORY_CONFIG';
export const INSIGNIA_ENABLED = 'INSIGNIA_ENABLED';
export const ACCESSORY_CONFIG_UPDATE = 'ACCESSORY_CONFIG_UPDATE';
export const ACCESSORY_UPDATE = 'ACCESSORY_UPDATE';

export const ACCESSORY_CONFIG_REQUEST = util.requestType(ACCESSORY_CONFIG);
export const ACCESSORY_CONFIG_SUCCESS = util.successType(ACCESSORY_CONFIG);
export const ACCESSORY_CONFIG_FAILURE = util.failureType(ACCESSORY_CONFIG);

export const ACCESSORY_CONFIG_UPDATE_REQUEST = util.requestType(
  ACCESSORY_CONFIG_UPDATE,
);
export const ACCESSORY_CONFIG_UPDATE_SUCCESS = util.successType(
  ACCESSORY_CONFIG_UPDATE,
);
export const ACCESSORY_CONFIG_UPDATE_FAILURE = util.failureType(
  ACCESSORY_CONFIG_UPDATE,
);

export const ACCESSORY_UPDATE_REQUEST = util.requestType(ACCESSORY_UPDATE);
export const ACCESSORY_UPDATE_SUCCESS = util.successType(ACCESSORY_UPDATE);
export const ACCESSORY_UPDATE_FAILURE = util.failureType(ACCESSORY_UPDATE);
export const INSIGNIA_ENABLED_REQUEST = util.requestType(INSIGNIA_ENABLED);
export const INSIGNIA_ENABLED_SUCCESS = util.successType(INSIGNIA_ENABLED);
export const INSIGNIA_ENABLED_FAILURE = util.failureType(INSIGNIA_ENABLED);
